import { Image, Text, VStack } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export const EmailConfirmation = () => {
  const [countdown, setCountdown] = useState<number>(5);
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev === 1) {
          clearInterval(timer);
          navigate("/");
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <VStack w={"100%"} h={"100%"} justify={"center"}>
      <Image src="/assets/svg/illustration_verified.svg" maxW={"400px"} />
      <Text fontSize={[24, null, 26]} fontWeight={"semibold"}>
        Email Berhasil Diverifikasi
      </Text>
      <Text fontSize={[14, null, 16]} variant={"secondary"}>
        Sekarang anda sudah bisa login dengan email yang sudah diverifikasi
      </Text>
      <Text fontSize={[12, null, 14]} variant={"secondary"}>
        Redirecting in {countdown} second{countdown !== 1 ? "s" : ""}...
      </Text>
    </VStack>
  );
};
